// ARQUIVO ATUALIZADO
import React from 'react';
import useData from '../hooks/useData';
import useToast from '../hooks/useToast';
import GlassCard from '../components/ui/Card';
import TaskSidebar from '../components/task-details/TaskSidebar';
import TaskMainContent from '../components/task-details/TaskMainContent';
import TaskHeader from '../components/task-details/TaskHeader';
import GlassButton from '../components/ui/Button';
import { ArchiveIcon } from '../components/ui/Icons';

const TaskDetails = ({ task, onBack, onDelete, onDeleteCommentRequest }) => {
    const { handleUpdateTask, handleSaveTask } = useData();
    const { showToast } = useToast();

    if (!task) return null;

    const handleArchive = () => {
        handleUpdateTask(task.id, { isArchived: true }, 'arquivou a tarefa.');
        showToast("Tarefa arquivada!");
        onBack(); 
    };

    const handleDuplicate = async () => {
        const { id, createdAt, history, ...originalTask } = task;
        const duplicatedTask = { 
            ...originalTask, 
            title: `${originalTask.title} (Cópia)`, 
            status: 'A Fazer',
            alterationChecklist: []
        };
        await handleSaveTask(duplicatedTask);
        showToast("Tarefa duplicada com sucesso!");
        onBack();
    };

    const handleCompleteTask = () => {
        if (task.status !== 'Concluído') {
            handleUpdateTask(task.id, { status: 'Concluído', isArchived: true }, 'marcou a tarefa como Concluída e a arquivou.');
            showToast("Tarefa Concluída e Arquivada!");
            onBack();
        }
    };
    
    const handleSaveTitle = (newTitle) => {
        if (!newTitle.trim()) {
            showToast("O título não pode ficar vazio.", "error");
            return;
        }
        if (newTitle !== task.title) {
            handleUpdateTask(task.id, { title: newTitle }, `renomeou a tarefa para "${newTitle}".`);
            showToast("Título atualizado!");
        }
    };

    return (
        <GlassCard className="w-full h-full max-h-[90vh] flex flex-col p-0 animate-fade-in-up">
            {/* O botão para adicionar ao "Meu Dia" será adicionado dentro do TaskHeader */}
            <TaskHeader 
                task={task} 
                onBack={onBack}
                onComplete={handleCompleteTask}
                onArchive={handleArchive}
                onDuplicate={handleDuplicate}
                onDelete={onDelete}
                onSaveTitle={handleSaveTitle}
            />
            <div className="flex-grow overflow-y-auto p-4 sm:p-6">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                    <TaskMainContent task={task} onDeleteCommentRequest={onDeleteCommentRequest} />
                    <TaskSidebar task={task} />
                </div>
                {task.status === 'Concluído' && (
                    <div className="mt-6 p-4 bg-emerald-500/10 border border-emerald-500/30 rounded-lg text-center animate-fade-in">
                        <p className="text-white mb-3">Esta tarefa está concluída.</p>
                        <GlassButton onClick={handleArchive} className="!bg-white/10 hover:!bg-white/20">
                            <ArchiveIcon size={16}/>
                            <span className="ml-2">Arquivar Tarefa</span>
                        </GlassButton>
                    </div>
                )}
            </div>
        </GlassCard>
    );
};

export default TaskDetails;